import { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Fabric from "@/components/site/Fabric";
import Governance from "@/components/site/Governance";
import RequestSection from "@/components/site/RequestSection";
import Footer from "@/components/site/Footer";
import DemoModal from "@/components/site/DemoModal";

function App() {
  const [demoOpen, setDemoOpen] = useState(false);
  const openDemo = () => setDemoOpen(true);

  return (
    <div
      className="bg-parchment text-ink min-h-screen antialiased selection:bg-linen selection:text-ink"
      data-testid="sureloom-page"
    >
      <Nav onBookDemo={openDemo} />
      <Hero onBookDemo={openDemo} />
      <Marquee />
      <Fabric />
      <Governance />
      <RequestSection />
      <Footer />
      <DemoModal open={demoOpen} onOpenChange={setDemoOpen} />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
